import type { TypeaheadOption } from 'components/inputs/typeahead';
import { PhoneTextability, phoneKey } from 'hooks/use-phone-textability';

/**
 * Typeahead options for a customer's phone numbers, annotated with what
 * pnet-api knows about texting each one: a textable number shows its line
 * type ("(312) 555-1234 · Mobile"), a number that cannot be texted is listed
 * disabled (red) with the reason, and an unclassified number is listed plain.
 */
export function buildPhoneOptions(
  phones: string[],
  byKey: Record<string, PhoneTextability>
): TypeaheadOption[] {
  return phones.map((phone) => {
    const textability = byKey[phoneKey(phone)];
    if (textability?.blocked) {
      return {
        label: `${phone} — ${textability.reason}`,
        value: phone,
        isDisabled: true
      };
    }
    return {
      label: textability?.lineTypeLabel
        ? `${phone} · ${textability.lineTypeLabel}`
        : phone,
      value: phone
    };
  });
}
